import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["column"] // Multiple lists (columns)

  connect() {
    this.initializeSortable()
    console.log("Kanban controller connected")
  }

  initializeSortable() {
    this.columnTargets.forEach((column) => {
      Sortable.create(column, {
        group: "shared", // This enables dragging between columns
        animation: 200,
        ghostClass: "opacity-20",
        handle: ".kanban-card", // Makes the entire card draggable
        onEnd: this.reorder.bind(this),
        removeCloneOnHide: true,
      })
    })
  }

  reorder(event) {
    const fromIndex = event.oldIndex
    const toIndex = event.newIndex
    const fromColumn = event.from.dataset.columnId // Get from column
    const toColumn = event.to.dataset.columnId // Get to column

    console.log(
      `Card moved from column ${fromColumn} (index: ${fromIndex}) to column ${toColumn} (index: ${toIndex})`
    )
    // You can add your logic here to handle the movement of cards between columns.
  }
}
